export default __webpack_public_path__ + "static/media/ai_motionActive.483d49a3.svg";